module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('link', {
    attrs: {
      "href": "https://unpkg.com/uppy@1.2.0/dist/uppy.min.css",
      "rel": "stylesheet"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-63abe926"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uppy.vue
// module id = 1051
// module chunks = 0